/**
 * App date component
 */

// React
import React, { ReactNode } from 'react';

// Material
import { Checkbox, CheckboxProps, FormControlLabel, Typography } from '@mui/material';

// Interface
interface AppCheckboxProps extends CheckboxProps {
  name?: string;
  icon?: React.ReactNode;
  checkedIcon?: React.ReactNode;
  label?: string | React.ReactNode;
}

// Component
export const AppCheckbox = React.forwardRef<HTMLButtonElement, AppCheckboxProps>((props, ref) => {
  const { label, icon, checkedIcon, ...rest } = props;

  const renderLabel = (): ReactNode => {
    if (typeof label === 'string') {
      return <Typography fontWeight={600}>{label}</Typography>;
    }

    return label;
  };

  return (
    <FormControlLabel
      control={<Checkbox ref={ref} icon={icon} checkedIcon={checkedIcon} {...rest} />}
      label={renderLabel()}
    />
  );
});
